module.exports = __webpack_public_path__ + "img/fund-step5.175003d1.png";